import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../../../SectionTitle';
import { NumericFormatter } from '../Formatters';

var FormatNumericSettings = function FormatNumericSettings(_ref) {
  var formatValue = _ref.formatValue,
      onUpdateFormatValue = _ref.onUpdateFormatValue,
      isDisabled = _ref.isDisabled;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement("div", null, React.createElement(SectionTitle, {
    title: t('widget_customization_format_value_settings.section_title'),
    description: t('widget_customization_format_value_settings.section_description'),
    onClear: isDisabled ? null : function () {
      return onUpdateFormatValue(null);
    }
  }), React.createElement(NumericFormatter, {
    formatValue: formatValue,
    onUpdateFormatValue: onUpdateFormatValue
  }));
};

export default FormatNumericSettings;